import React, { useEffect, useState } from "react";
import { Default } from "../../components/default/Default";
import PostRequest from "../../services/PostRequest";
import moment from "moment/moment";
import "./update-news.css";

const UpdateNews = () => {
  const [news, setNews] = useState([]);
  const [loader, setLoader] = useState(false);

  const getNews = async () => {
    try {
      setLoader(true);
      const response = await PostRequest("/news/get_news/");
      setNews(response);
    } catch (error) {
      console.log("error", error.message);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getNews();
  }, []);

  const getBadgeClass = (type) => {
    if (type === "feature") {
      return "mca-badge--soft-success";
    } else if (type === "bug_fixed") {
      return "mca-badge--soft-danger";
    } else if (type === "update") {
      return "mca-badge--soft-warning";
    } else {
      return "mca-badge--soft-info";
    }
  };

  const formatBadgeText = (type) => {
    const typeMap = {
      feature: "New",
      bug_fixed: "Bug Fix",
      update: "Improvement",
      improvement: "Improvement",
      heads_up: "Heads up",
    };
    return typeMap[type] || type?.replace(/_/g, " ")?.toUpperCase() || "Update";
  };

  if (loader) {
    return (
      <Default>
        <div className="mca-content">
          <div style={{ textAlign: "center", padding: "40px" }}>
            <p style={{ color: "var(--mca-muted)" }}>Loading updates...</p>
          </div>
        </div>
      </Default>
    );
  }

  if (!news || news.length === 0) {
    return (
      <Default>
        <div className="mca-content">
          <div style={{ marginBottom: "26px" }}>
            <h1 style={{ fontSize: "26px", fontWeight: "700", letterSpacing: "-0.02em" }}>
              Updates &amp; news
            </h1>
            <p style={{ color: "var(--mca-muted)", fontSize: "14px", margin: "6px 0 0" }}>
              Product changes, new features, and platform status.
            </p>
          </div>
          <div style={{ padding: "40px", textAlign: "center" }}>
            <p style={{ color: "var(--mca-muted)" }}>No updates available.</p>
          </div>
        </div>
      </Default>
    );
  }

  return (
    <Default>
      <div className="mca-content">
        <div style={{ marginBottom: "26px" }}>
          <h1 style={{ fontSize: "26px", fontWeight: "700", letterSpacing: "-0.02em" }}>
            Updates &amp; news
          </h1>
          <p style={{ color: "var(--mca-muted)", fontSize: "14px", margin: "6px 0 0" }}>
            Product changes, new features, and platform status.
          </p>
        </div>

        <div className="feed">
          {news.map((item, index) => {
            const isLast = index === news.length - 1;
            return (
              <div key={index} className="feed-item">
                <div className="feed-rail">
                  <span className="feed-dot"></span>
                  {!isLast && <span className="feed-line"></span>}
                </div>
                <div className="feed-card">
                  <div className="mca-card mca-card--pad">
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px" }}>
                      <span className="feed-date">{moment(item.updated_at).format("MMM D, YYYY").toUpperCase()}</span>
                      {item.type && (
                        <span className={`mca-badge ${getBadgeClass(item.type)}`}>
                          {formatBadgeText(item.type)}
                        </span>
                      )}
                    </div>
                    <div className="feed-title">{item.title}</div>
                    <div className="feed-body">
                      <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Default>
  );
};

export default UpdateNews;
